import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
// import { Logger, I18nService } from '@app/core';

// const log = new Logger('App');

@Component({
  selector: 'app-file-uploader',
  // host: {'class': 'attachment' },
  template: `
    <label class="attachment" [ngClass]="{ active: dropPosition }">
      <div *ngIf="!dropPosition">
        <div class="text-ellipsis" *ngIf="filename">{{ filename }}</div>
        <div class="text-ellipsis" *ngIf="!filename"><ng-content></ng-content></div>
      </div>
      <div *ngIf="dropPosition"><div>Drop file here...</div></div>
      <input type="file" #input [name]="name" accept="{{ type }}" />
    </label>
  `,
  styles: [
    `
      :host {
        max-width: 300px;
        display: block;
        margin-bottom: 10px;
        height: 45px;
        min-width: 140px;
        border-style: solid;
        border-width: 1px;
        border-color: hsla(0, 0%, 100%, 0.1);
        border-radius: 6px;
        background-color: transparent;
        box-shadow: 11px 11px 30px 0 transparent;
        -webkit-transition: box-shadow 200ms ease, -webkit-transform 500ms cubic-bezier(0.23, 1, 0.32, 1);
        transition: box-shadow 200ms ease, -webkit-transform 500ms cubic-bezier(0.23, 1, 0.32, 1);
        transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1), box-shadow 200ms ease;
        transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1), box-shadow 200ms ease,
          -webkit-transform 500ms cubic-bezier(0.23, 1, 0.32, 1);
        font-size: 12px;
        line-height: 45px;
        text-align: center;
      }

      .attachment {
        text-align: center;
        width: 100%;
        height: 100%;
      }

      .document-plus-icon {
        margin-top: 5px;
        font-size: 15px;
        font-weight: 300;
      }

      .attachment.active {
        border-style: dashed;
        border-radius: 6px;
        line-height: 36px;
      }

      .attachment:hover {
        border-color: #3ecf8e;
        color: #3ecf8e;
      }

      .attachment.active {
        opacity: 0.5;
      }

      .attachment input {
        position: absolute;
        overlay: 0;
        left: -999999px;
        width: 0;
        height: 0;
      }

      .text-ellipsis {
        /*display: inline-block;*/
        /*max-width: 230px;*/
        width: 90%;
        margin-left: 5%;
        margin-right: 5%;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
      }

      @media (max-width: 991px) {
        .text-ellipsis {
          white-space: pre-wrap !important;
          color: white !important;
        }
        .ng-star-inserted .far {
          color: white !important;
        }
      }
    `,
  ],
})
export class FileUploaderComponent implements OnInit {
  @Input() public label = 'Attach a photo';
  @Input() public type = 'image/*,application/pdf,application/x+pdf;capture=camera';
  @Input() public name: string = 'file';
  @Input() public uploader: any = { options: {} };
  @Input() public loading: boolean = false;
  @Output() public files: EventEmitter<FileList[]> = new EventEmitter<FileList[]>();

  @ViewChild('input') input: ElementRef;

  filename: string;
  dropPosition = false;

  protected element: ElementRef;

  public constructor(element: ElementRef) {
    this.element = element;
  }

  public getOptions(): any {
    return this.uploader.options;
  }

  public getFilters(): any {
    return {};
  }

  ngOnInit() {
    this.input.nativeElement.addEventListener('change', e => {
      this.files.emit(this.input.nativeElement.files);
      this.filename = this.input.nativeElement.files[0].name;
    });
  }

  @HostListener('drop', ['$event'])
  public onDrop(event: any): void {
    this._preventAndStop(event);
    let typeResult = false;
    if (event.dataTransfer.files[0].type.indexOf(this.type) > -1) {
      typeResult = true;
    }
    if (typeResult) {
      // event.dataTransfer.files[0].name
      this.files.emit(event.dataTransfer.files);
      this.filename = event.dataTransfer.files[0].name;
    }
    this.dropPosition = false;
  }

  @HostListener('dragover', ['$event'])
  public onDragOver(event: any): void {
    const transfer = this._getTransfer(event);
    if (!this._haveFiles(transfer.types)) {
      return;
    }
    this.dropPosition = true;

    transfer.dropEffect = 'copy';
    this._preventAndStop(event);
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(event: any): any {
    if ((this as any).element) {
      if (event.currentTarget === (this as any).element[0]) {
        return;
      }
    }
    this.dropPosition = false;
    this._preventAndStop(event);
  }

  protected _getTransfer(event: any): any {
    return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
  }

  protected _preventAndStop(event: any): any {
    event.preventDefault();
    event.stopPropagation();
  }

  protected _haveFiles(types: any): any {
    if (!types) {
      return false;
    }

    if (types.indexOf) {
      return types.indexOf('Files') !== -1;
    } else if (types.contains) {
      return types.contains('Files');
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/file-uploader.component.ts